/**
 * This is a workaround for the "ResizeObserver loop completed with undelivered notifications" error.
 * This error is benign and often occurs when using libraries like vis-network or recharts.
 * The error happens when the ResizeObserver callback triggers a layout change in the same frame.
 * We wrap the callback in requestAnimationFrame to defer it to the next frame.
 */
export const fixResizeObserverLoop = () => {
  const originalResizeObserver = window.ResizeObserver;

  if (!originalResizeObserver) {
    return; // ResizeObserver not supported
  }

  window.ResizeObserver = class ResizeObserver extends originalResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      super((entries, observer) => {
        // Defer the callback to the next animation frame to avoid the loop error
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
};

